export default __webpack_public_path__ + "static/work-at-toggl-26d0a1826a82311e727264a199eeec16.jpg";